export const RESET_STATE = Symbol('copyEntriesToWorkbook/RESET_STATE');

export const GET_ENTRY_LOADING = Symbol('copyEntriesToWorkbook/GET_ENTRY_LOADING');
export const GET_ENTRY_SUCCESS = Symbol('copyEntriesToWorkbook/GET_ENTRY_SUCCESS');
export const GET_ENTRY_FAILED = Symbol('copyEntriesToWorkbook/GET_ENTRY_FAILED');

export const GET_RELATIONS_LOADING = Symbol('copyEntriesToWorkbook/GET_RELATIONS_LOADING');
export const GET_RELATIONS_SUCCESS = Symbol('copyEntriesToWorkbook/GET_RELATIONS_SUCCESS');
export const GET_RELATIONS_FAILED = Symbol('copyEntriesToWorkbook/COPY_ENTRY_GRAPH_FAILED');

export const COPY_ENTRIES_TO_WORKBOOK_LOADING = Symbol(
    'copyEntriesToWorkbook/COPY_ENTRIES_TO_WORKBOOK_LOADING',
);
export const COPY_ENTRIES_TO_WORKBOOK_SUCCESS = Symbol(
    'copyEntriesToWorkbook/COPY_ENTRIES_TO_WORKBOOK_SUCCESS',
);
export const COPY_ENTRIES_TO_WORKBOOK_FAILED = Symbol(
    'copyEntriesToWorkbook/COPY_ENTRIES_TO_WORKBOOK_FAILED',
);
